// extracted by mini-css-extract-plugin
export var buttonwrapper = "ParagraphButton-module--buttonwrapper--06ad6";
export var sectionwrapperinner = "ParagraphButton-module--sectionwrapperinner--72a65";
export var sectionwrapperouter = "ParagraphButton-module--sectionwrapperouter--4ba33";